import React from "react";
import { Fade } from "react-awesome-reveal";
import Whats from "./Whats";
import "../styles/Promo.scss";

export const Promo = () => {
  return (
    <section className="promoContainerMain" aria-label="Promoción Pixbae Banquetes">
      <div className="promoContainer">
        <div className="promoLeft">
          <Fade triggerOnce>
            <p className="promoText">
              🔥 <strong>Banquetes al carbón premium</strong> para eventos
              residenciales y empresariales en{" "}
              <strong>Guadalajara, Zapopan y Tlajomulco</strong>.
            </p>
          </Fade>
        </div>

        <div className="promoRight">
          <Fade direction="left" triggerOnce>
            <Whats
              classStyle="btn btnPromo"
              message="Hola, quiero cotizar un banquete. ¿Me compartes paquetes y disponibilidad?"
              text="Cotizar por WhatsApp"
              phoneNumber="523345851702"
            />
          </Fade>
        </div>
      </div>
    </section>
  );
};

export default Promo;
